export default "__VITE_ASSET__C9FB4Q5L__"